import React, { useMemo } from 'react';
import CollapsibleFilterPanel, { FilterField } from './CollapsibleFilterPanel';

const ELO_OPTIONS = [
  { value: 'mixed', label: 'Mixed ELO' },
  { value: 'levels', label: 'Levels ELO' },
];

const GENDER_OPTIONS = [
  { value: 'all', label: 'All players' },
  { value: 'male', label: 'Male only' },
  { value: 'female', label: 'Female only' },
];

const controlClass = 'form-input w-full min-w-0 text-sm py-1.5 sm:py-2';

export default function ClubAnalysisLeaderboardFilters({
  seasons = [],
  leaderboardSeason,
  onSeasonChange,
  eloFilter,
  onEloFilterChange,
  genderFilter,
  onGenderFilterChange,
}) {
  const seasonLabel =
    leaderboardSeason?.name ||
    (leaderboardSeason?.season_number != null ? `Season ${leaderboardSeason.season_number}` : null) ||
    'All seasons';

  const eloLabel = ELO_OPTIONS.find((o) => o.value === eloFilter)?.label ?? 'Mixed ELO';
  const genderLabel = GENDER_OPTIONS.find((o) => o.value === genderFilter)?.label ?? 'All players';

  const hasActiveFilters =
    Boolean(leaderboardSeason?.id) || eloFilter !== 'mixed' || genderFilter !== 'all';

  const summary = useMemo(
    () => [seasonLabel, eloLabel, genderLabel].join(' · '),
    [seasonLabel, eloLabel, genderLabel]
  );

  return (
    <CollapsibleFilterPanel summary={summary} hasActiveFilters={hasActiveFilters} ariaLabel="Leaderboard filters">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-4">
        <FilterField id="club-analysis-lb-season" label="Season" labelShort="Season">
          <select
            id="club-analysis-lb-season"
            value={leaderboardSeason?.id ?? ''}
            onChange={(e) => {
              const id = e.target.value;
              onSeasonChange(id ? seasons.find((s) => s.id === id) || null : null);
            }}
            className={controlClass}
          >
            <option value="">All seasons</option>
            {seasons.map((s) => (
              <option key={s.id} value={s.id}>
                {s.name || `Season ${s.season_number}`}
              </option>
            ))}
          </select>
        </FilterField>

        <FilterField id="club-analysis-lb-elo" label="ELO rating type" labelShort="ELO type">
          <select
            id="club-analysis-lb-elo"
            value={eloFilter}
            onChange={(e) => onEloFilterChange(e.target.value)}
            className={controlClass}
          >
            {ELO_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </FilterField>

        <FilterField id="club-analysis-lb-gender" label="Gender filter" labelShort="Gender">
          <select
            id="club-analysis-lb-gender"
            value={genderFilter}
            onChange={(e) => onGenderFilterChange(e.target.value)}
            className={controlClass}
          >
            {GENDER_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </FilterField>
      </div>
    </CollapsibleFilterPanel>
  );
}
